import { Navigate, useRoutes } from 'react-router-dom';

import { mainRoutes } from './main';
import { authRoutes } from './auth';
import { teacherRoutes } from './teacher';
import { studentRoutes } from './student';
import { accountRoutes } from './account';
import { dashboardRoutes } from './dashboard';
// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to="/home" replace />,
    },

    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // Main routes
    ...mainRoutes,

    // Teacher routes
    ...teacherRoutes,

    // Student routes
    ...studentRoutes,

    // Account routes
    ...accountRoutes,
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
